(function() {
    'use strict';
    angular
        .module('ccsTrApp')
        .factory('Seller', Seller);

    Seller.$inject = ['$resource', 'DateUtils'];

    function Seller ($resource, DateUtils) {
        var resourceUrl =  'api/sellers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdOn = DateUtils.convertDateTimeFromServer(data.createdOn);
                        data.modifiedOn = DateUtils.convertDateTimeFromServer(data.modifiedOn);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
